import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Platform } from 'react-native';
import { Icon } from 'LocalGluons/index';
// after libs update
import { Device } from 'DeviceUtils';
import { ProgramModel } from '@24i/st-api-connector';
import { StreamType, StyleMap, PlayerData, IconData } from '../../../../../types';
import PlayerProgressBar from '../PlayerProgressBar';
import { AdSkipPolicy } from '../../../PlayerContainer/hooks/useAdvertisements';
import defaultStyles from './PlayerFooter.jss';

const AirplayButton: any = Platform.select({
    default: () => null,// require('@24i/player-ui-react-native').AirplayButton,
    web: () => null
});

interface PlayerFooterProps {
    style: StyleMap[] | StyleMap;
    streamType: StreamType;
    item: PlayerData['item'];
    leftIcons?: IconData[];
    rightIcons?: Array<IconData | false>;
    onSeekerDragStart: () => void;
    onSeekerDragEnd: (a: any) => void;
    onSyntheticSeekerDragEnd: () => void;
    playerInstance: any;
    onDurationPress: () => void;
    onCurrentTimePress: () => void;
    maxTimeshift?: number;
    progressReplace?: any;
    adSkipPolicy: AdSkipPolicy;

}

const PlayerFooter = ({
    style,
    item,
    streamType,
    leftIcons = [],
    rightIcons = [],
    onSeekerDragStart,
    onSeekerDragEnd,
    onSyntheticSeekerDragEnd,
    playerInstance,
    onDurationPress,
    onCurrentTimePress,
    maxTimeshift,
    progressReplace = false,
    adSkipPolicy
}: PlayerFooterProps): JSX.Element => {
    const [isSynthetic, setIsSynthetic] = useState(false);
    useEffect(() => {
        if (item.modelType === 'tv') {
            if ((item as ProgramModel).getChannelType() === 'VOD') {
                setIsSynthetic(true);
            } else {
                setIsSynthetic(false);
            }
        }
    }, [item]);

    return (
        <View style={[defaultStyles.container, style]}>
            {!isSynthetic && (<View style={defaultStyles.iconRecordOffsetLeft}>
                {leftIcons.map((iconData) => (
                    <Icon
                        key={iconData.key}
                        style={StyleSheet.flatten([defaultStyles.icon, iconData.style])}
                        onPress={iconData.onPress}
                        name={iconData.name}
                        testID={`${iconData.key}_button`}
                    />
                ))}
            </View>)}
            <PlayerProgressBar
                testID="seeker"
                item={item}
                maxTimeshift={maxTimeshift}
                playerInstance={playerInstance}
                streamType={streamType}
                style={defaultStyles.progressBar}
                onSeekerDragStart={onSeekerDragStart}
                onSeekerDragEnd={onSeekerDragEnd}
                onSyntheticSeekerDragEnd={onSyntheticSeekerDragEnd}
                onDurationPress={onDurationPress}
                onCurrentTimePress={onCurrentTimePress}
                progressReplace={progressReplace}
                adSkipPolicy={adSkipPolicy}
            />
            {Device.isWeb && (
                <View style={[defaultStyles.iconsContainer]}>
                    {rightIcons.map((iconData) => {
                        if (!iconData) return null;
                        // if (iconData.type === 'AirPlay') {
                        //     return (
                        //         <View
                        //             key={iconData.key}
                        //             testID="AirPlay_button"
                        //             style={[defaultStyles.icon, airPlayStyles.button]}
                        //         >
                        //             <AirplayButton key="AirPlayIcon" playerInstance={playerInstance} />
                        //         </View>
                        //     );
                        // }
                        return (
                            <Icon
                                key={iconData.key}
                                style={[defaultStyles.icon, iconData.style]}
                                onPress={iconData.onPress}
                                name={iconData.name}
                                testID={`${iconData.key}_button`}
                            />
                        );
                    })}
                </View>
            )}
        </View>
    );
};

export default PlayerFooter;
